import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

const path = 'user-bl'
// 邀请接口要校验「当前登录的是谁」，带上 3.0 登录拿到的 satoken（hillo 全局没配 token；
// hillo 对 config 是浅合并，headers 要把默认的 JSON 头一起带上）
const authHeaders = () => ({ headers: { 'Content-Type': 'application/json', satoken: localStorage.getItem('token') ?? '' } })

export async function createInvite (item) {
  return (await hillo.jsonPost(cloudV2Url + path + '/invite', { ...item }, authHeaders()))
}

export async function acceptInvite (activeCode, userId) {
  return (await hillo.jsonPost(cloudV2Url + path + '/accept-invite', {
    activeCode, userId
  }, authHeaders()))
}

export async function deleteInvite () {
  return (await hillo.jsonPost(cloudV2Url + path + '/delete-invite', {}))
}

export async function refreshInvite () {
  return (await hillo.jsonPost(cloudV2Url + path + '/refresh-invite', {

  }))
}

export async function changeAuth () {
  return (await hillo.jsonPost(cloudV2Url + path + '/change-auth', {}))
}

export const authList =
[
  { text: 'DataCenter', value: 'DataCenter' },
  { text: 'Inventory', value: 'Inventory' },
  { text: 'Supplier', value: 'Supplier' },
  { text: 'Admin', value: 'Admin' },
  { text: 'Subscription', value: 'Subscription' },
  { text: 'Owner', value: 'Owner' }
]

export async function getBLForUser (userId) {
  return (await hillo.get(cloudV2Url + path + '/blForUser', { userId }))
}

export async function getInviteInfoByBlId (blId) {
  return (await hillo.get(cloudV2Url + path + '/users-by-device', {}, {
    params: { blId }
  }))
}
